<template>
  <AdministratProkurorive
    :prokuroriaId="prokuroriaId"
    :categoryId="categoryId"
    :language="language"/>

</template>

<script>

import AdministratProkurorive from '../share/AdministratProkuroriveMain.vue';
export default {
 components: { AdministratProkurorive },

  data() {
    return {
      prokuroriaId: 6,
      categoryId: 2210,
      language: 'AL',
    };  
  }
}
</script>

<style>

</style>